import * as React from 'react';
import { Vms } from './VmsMenu';

export interface IVmsMenuListProps {
    vms: Vms[];
    currentRegion: string;
}

export class VmsMenuList extends React.Component<IVmsMenuListProps> {
    constructor(props: IVmsMenuListProps) {
        super(props);
    }

    public render(): JSX.Element {
        return <ul>{this.props.vms.map(this.renderItem.bind(this))}</ul>;
    }

    private renderItem(item: Vms, index: number): JSX.Element {
        let startUrl = '/stockholm';

        if (this.props.currentRegion.toUpperCase() === 'GBG') {
            startUrl = '/goteborg';
        }

        return (
            <li key={index} className={item.isCurrent ? 'current' : ''}>
                <a href={startUrl + item.url}>
                    <span>{item.name}</span>
                </a>
            </li>
        );
    }
}
